import { useEffect, useState } from "react";

import classnames from "classnames";

import { YMaxLocker, YMinLocker } from "../AxisLocker";
import { MpLockWrapper } from "../AxisLocker/AxisLocker.styles";
import { Wrapper } from "./AxisContainer.styles";

export function YAxisContainer({
  onInputStateChange,
  isMultiProductActive = false,
  yAxisArray = []
}) {
  const [isInputActive, setIsInputActive] = useState(false);

  const wrapperClassnames = classnames({
    yAxis: true
  });

  useEffect(() => {
    onInputStateChange(isInputActive);
  }, [isInputActive, onInputStateChange]);

  // If multiProduct is active, render each axis pair positioned using the
  // dynamically computed lockPosition from chart options.
  if (isMultiProductActive && yAxisArray.length >= 1) {
    return (
      <>
        {yAxisArray.map((axis, index) => {
          const lockPos = axis?.lockPosition;
          if (lockPos == null) {
            // Fallback: render at default position if lockPosition not yet computed
            return (
              <Wrapper key={index} className={wrapperClassnames}>
                <YMaxLocker onInputStateChange={setIsInputActive} yAxisIndex={index} />
                <YMinLocker onInputStateChange={setIsInputActive} yAxisIndex={index} />
              </Wrapper>
            );
          }
          return (
            <div
              key={index}
              style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
              <MpLockWrapper
                $lockPosition={lockPos}
                $variant="min"
                data-axis-index={index}
                data-variant="y-min">
                <YMinLocker onInputStateChange={setIsInputActive} yAxisIndex={index} />
              </MpLockWrapper>
              <MpLockWrapper
                $lockPosition={lockPos}
                $variant="max"
                data-axis-index={index}
                data-variant="y-max">
                <YMaxLocker onInputStateChange={setIsInputActive} yAxisIndex={index} />
              </MpLockWrapper>
            </div>
          );
        })}
      </>
    );
  }

  // Default single axis behavior — render primary locks plus optional secondary (y2) locks
  const primaryAxis = yAxisArray[0];
  const wellCountAxis = yAxisArray[1];
  const showWellCountLocks = wellCountAxis?.lock?.show && wellCountAxis?.lockPosition;

  const primaryLocks =
    primaryAxis?.isTotalRateDateLockPosition && primaryAxis?.lockPosition ? (
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <MpLockWrapper
          $lockPosition={primaryAxis.lockPosition}
          $variant="max"
          data-axis-index={0}
          data-variant="y-max">
          <YMaxLocker onInputStateChange={setIsInputActive} />
        </MpLockWrapper>
        <MpLockWrapper
          $lockPosition={primaryAxis.lockPosition}
          $variant="min"
          data-axis-index={0}
          data-variant="y-min">
          <YMinLocker onInputStateChange={setIsInputActive} />
        </MpLockWrapper>
      </div>
    ) : (
      <Wrapper className={wrapperClassnames}>
        <YMaxLocker onInputStateChange={setIsInputActive} />
        <YMinLocker onInputStateChange={setIsInputActive} />
      </Wrapper>
    );

  return (
    <>
      {primaryLocks}
      {showWellCountLocks && (
        <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
          <MpLockWrapper
            $lockPosition={wellCountAxis.lockPosition}
            $variant="max"
            data-axis-index={1}
            data-variant="y2-max">
            <YMaxLocker onInputStateChange={setIsInputActive} yAxisIndex={1} />
          </MpLockWrapper>
          <MpLockWrapper
            $lockPosition={wellCountAxis.lockPosition}
            $variant="min"
            data-axis-index={1}
            data-variant="y2-min">
            <YMinLocker onInputStateChange={setIsInputActive} yAxisIndex={1} />
          </MpLockWrapper>
        </div>
      )}
    </>
  );
}
